import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'filter.gender.title',
    defaultMessage: 'Genre',
  },
  other: {
    id: 'filter.gender.other',
    defaultMessage: 'Indifférent 👨👩‍',
  },
  man: {
    id: 'filter.gender.man',
    defaultMessage: 'Homme 👨',
  },
  woman: {
    id: 'filter.gender.woman',
    defaultMessage: 'Femme 👩‍',
  },
});
